const Foodsection = () => {

    return <div className="fresh-food-section mt-4 pt-5 pb-5" id="freshfoodsection">
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-5">
          <div className="text-center">
            <img className="healthy-food-section-img"
              src="https://d1tgh8fmlzexmh.cloudfront.net/ccbp-responsive-website/healthy-food-plate-img.png"
            />
          </div>
        </div>
        <div className="col-12 col-md-7">
          <h1 className="healthy-food-section-heading">
            Fresh, Healthy, Organic, Delicious Fruits
          </h1>
          <p className="healthy-food-section-description">
            Say no to harmful chemicals and go fully organic with our range of
            fresh fruits and veggies. Pamper your body and your sensess with
            the truw and unadulterated gifts from mother nature. with the truw
            and unadulterated gifts from mother nature.
          </p>
          <button className="btn btn-warning">Watch Video</button>
        </div>
      </div>
    </div>
  </div>

} 

export default Foodsection